import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Settings from './Settings';
import { useLocation } from 'react-router-dom';

function SettingsIndex(props) {
  const showMessage = (color, position, title, content) => {
    props.showMessage(color, position, title, content);
  };
  const location = useLocation();
  const routes = props.config.childs.map((r, index) => {
    return (
      <Route
        path={`/protected/admin${r.path}`}
        render={(props) => {
          return (
            <r.component {...props} config={r} showMessage={showMessage} />
          );
        }}
        key={index}
      />
    );
  });

  return (
    <>
      {`/protected/admin${props.config.path}` === location.pathname ? (
        <Settings showMessage={showMessage} config={props.config} {...props} />
      ) : (
        <Switch>{routes}</Switch>
      )}
    </>
  );
}
export default SettingsIndex;
